var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button__container",on:{"click":_vm.onBack}},[_vm._t("prefixIcon",function(){return [_c('i',{staticClass:"el-icon-arrow-left"})]}),_vm._v(" "),_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.system.backPreviousPageTxt))])]}),_vm._v(" "),_vm._t("suffixIcon")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e89648a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackButton.vue
// module id = null
// module chunks = 